module.exports = __webpack_public_path__ + "static/media/Team-completed-project2.09eb6c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Team-completed-project2.png
// module id = 576
// module chunks = 0